import { render, staticRenderFns } from "./DiscountView.vue?vue&type=template&id=f5c7372a&"
import script from "./DiscountView.vue?vue&type=script&lang=js&"
export * from "./DiscountView.vue?vue&type=script&lang=js&"
import style0 from "./DiscountView.vue?vue&type=style&index=0&id=f5c7372a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports